import { render, staticRenderFns } from "./MealTypeNav.vue?vue&type=template&id=b6bbe97e&scoped=true&"
import script from "./MealTypeNav.vue?vue&type=script&lang=js&"
export * from "./MealTypeNav.vue?vue&type=script&lang=js&"
import style0 from "./MealTypeNav.vue?vue&type=style&index=0&id=b6bbe97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bbe97e",
  null
  
)

export default component.exports